var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 17 16",
    "data-icon": "googleWhite",
    className: "inline-block",
    style: {
      width: 24,
      minWidth: 24,
      height: 24,
      minHeight: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8833 8.15003C14.8833 7.71114 14.8444 7.29447 14.7778 6.88892H8.5V9.39447H12.0944C11.9333 10.2167 11.4611 10.9111 10.7611 11.3834V13.05H12.9056C14.1611 11.8889 14.8833 10.1778 14.8833 8.15003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50005 14.6667C10.3 14.6667 11.8056 14.0667 12.9056 13.05L10.7612 11.3833C10.1612 11.7833 9.40005 12.0278 8.50005 12.0278C6.76116 12.0278 5.28894 10.8555 4.76116 9.27222H2.55005V10.9889C3.64449 13.1667 5.89449 14.6667 8.50005 14.6667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76115 9.27225C4.62226 8.87225 4.55004 8.44447 4.55004 8.00003C4.55004 7.55558 4.62782 7.12781 4.76115 6.72781V5.01114H2.55004C2.09448 5.91114 1.83337 6.92225 1.83337 8.00003C1.83337 9.0778 2.09448 10.0889 2.55004 10.9889L4.76115 9.27225Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50005 3.97223C9.48338 3.97223 10.3612 4.31112 11.0556 4.97223L12.9556 3.07223C11.8056 1.99446 10.3 1.33334 8.50005 1.33334C5.89449 1.33334 3.64449 2.83334 2.55005 5.01112L4.76116 6.72779C5.28894 5.14446 6.76116 3.97223 8.50005 3.97223Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.01d2a14a0c34dd82ddd5bfc9900ad93e.svg";
export { ForwardRef as ReactComponent };